<template>
  <footer class="site-footer">
    <div class="footer-particles-container">
      <canvas id="footer-particles" />
    </div>
    <div
      v-if="!showText"
      class="site-footer-top">
    </div>
    <div class="site-footer-bottom">
      <div class="container-herohire">
        <div class="site-footer-inner">
          <div class="brand footer-brand">
            <a href="#">
              <img
                src="@/assets/herohire-logo.png"
                alt="Hero Hire logo"
                width="100">
            </a>
            <a
              href="https://koffeestudios.com"
              class="margin-left-2 margin-top-1">
              <img
                src="@/assets/koffee_logo_primary.png"
                alt="Koffee Studios logo"
                width="100">
            </a>
          </div>
          <ul class="footer-links list-reset">
            <li>
              <router-link to="home">
                Home
              </router-link>
            </li>
            <li>
              <router-link to="privacy-policy">
                Privacy Policy
              </router-link>
            </li>
            <li>
              <router-link to="dashboard">
                Dashboard
              </router-link>
            </li>
            <li>
              <router-link to="account-registration">
                Registration
              </router-link>
            </li>
            <li>
              <!-- <a href="#">Support</a> -->
            </li>
          </ul>
          <ul class="footer-social-links list-reset">
            <li>
              <a href="https://www.facebook.com/HeroHireApp">
                <span class="screen-reader-text">Facebook</span>
                <svg
                  width="16"
                  height="16"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M6.023 16L6 9H3V6h3V4c0-2.7 1.672-4 4.08-4 1.153 0 2.144.086 2.433.124v2.821h-1.67c-1.31 0-1.563.623-1.563 1.536V6H13l-1 3H9.28v7H6.023z"
                    fill="#FFF" />
                </svg>
              </a>
            </li>
          </ul>
          <div class="footer-copyright">
            &copy; {{ date }} Koffee Studios, all rights reserved
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  props: {
    showText: Boolean
  },
  data() {
    return {
      date: new Date().getFullYear()
    }
  }
};
</script>

<style>
</style>
